module.exports = __webpack_public_path__ + "img/airplane-1.0ca9fa50.jpg";